export default __webpack_public_path__ + "static/media/pantry1-afterC-768w.34081c03.webp";